'use client';

import { useTranslations } from 'next-intl';
import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { SITE } from '@/app/constants';
import { cn, reportEvent } from '@/app/utils';
import { Link } from '@/i18n/routing';

export const DoubleFestivalBanner = ({ onClose, className }: { onClose: () => void; className?: string }) => {
  const t = useTranslations(SITE === 'china' ? 'doubleFestival' : 'doubleFestival.global');
  return (
    <div className={cn('relative aspect-[80/3] w-full shrink-0 bg-[#969acb] sm:aspect-[95/12]', className)}>
      <picture>
        <source
          media="(max-width: 767px)"
          srcSet={
            SITE === 'china'
              ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/Frame%201686559285-d59e049f.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/Frame%201686559286-d448bb15.webp'
          }
          width={1140}
          height={144}
        />
        <img
          src={
            SITE === 'china'
              ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/china-landing-banner-40b96a4e.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/global-landing-banner-279b40d8.webp'
          }
          width={1920}
          height={72}
          alt=""
          className="pointer-events-none absolute inset-0 size-full"
        />
      </picture>
      <Link
        href="/subscription/personal"
        aria-label={t('headline')}
        onClick={() => reportEvent('element_click', { element_name: 'double_festival_banner' })}
        className="absolute inset-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
      />
      <button
        type="button"
        onClick={onClose}
        aria-label={t('close')}
        className="-translate-y-1/2 absolute top-1/2 right-5 flex aspect-square h-full max-h-8 items-center justify-center rounded-full text-white hover:bg-white/10 sm:right-0 sm:aspect-auto sm:max-h-none sm:w-6"
      >
        <BaseLineClose className="size-6 sm:size-4" />
      </button>
    </div>
  );
};
